const helperPrompt = "Käännä seuraava prompti luonnolliseksi englanniksi muuttamatta sisältöä. Säilytä merkitys, rakenne, tyyli, yksityiskohdat ja negatiiviset ohjeet. Älä lisää uusia asioita äläkä poista mitään olennaista. Tee lopputuloksesta suoraan kopioitava kuva-, video-, musiikki- tai äänityökaluun.";

export const VisualTranslationHint = ({ testIdPrefix = "visual-translation-hint" }) => (
  <section className="mt-4 rounded-[1.25rem] border border-[#E8E5D9] bg-[#FDFCF8] p-4" data-testid={`${testIdPrefix}-section`}>
    <h3 className="font-heading text-lg font-bold text-[#2C2F2E]" data-testid={`${testIdPrefix}-title`}>Jos käytät englanniksi paremmin toimivaa työkalua:</h3>
    <p className="mt-2 text-sm leading-6 text-[#5C6360]" data-testid={`${testIdPrefix}-instructions`}>
      Kopioi ensin yllä oleva prompti ChatGPT:hen tai Claudeen ja pyydä:
    </p>
    <blockquote className="mt-3 rounded-2xl bg-[#F5F3EC] p-4 text-sm font-bold leading-6 text-[#2C2F2E]" data-testid={`${testIdPrefix}-short-request`}>
      “Käännä tämä prompti luonnolliseksi englanniksi muuttamatta sisältöä.”
    </blockquote>
    <p className="mt-3 text-sm leading-6 text-[#5C6360]" data-testid={`${testIdPrefix}-followup`}>
      Sen jälkeen liitä englanninkielinen versio haluamaasi kuva-, video-, musiikki- tai äänityökaluun.
    </p>
    <label htmlFor={`${testIdPrefix}-helper-prompt`} className="mt-4 block text-sm font-bold text-[#2C2F2E]" data-testid={`${testIdPrefix}-helper-label`}>
      Vaihtoehtoinen kopioitava käännöspyyntö
    </label>
    <textarea
      id={`${testIdPrefix}-helper-prompt`}
      readOnly
      value={helperPrompt}
      className="mt-2 min-h-28 w-full resize-y rounded-2xl border border-transparent bg-[#F5F3EC] px-4 py-3 text-sm leading-6 text-[#2C2F2E] outline-none focus:border-[#4A6753]/40 focus:bg-white focus:ring-4 focus:ring-[#4A6753]/10"
      data-testid={`${testIdPrefix}-helper-textarea`}
    />
  </section>
);